import React from "react";
import PropTypes from "prop-types";
import SaveOfferModal from "components/v3/save-offer/SaveOfferModal";
import { getDate } from "common/utils/dateUtil";

import {
    STATUS_CANCELLED,
    STATUS_EXPIRED,
    SUBSCRIPTION_BILLING_PERIOD
} from "common/constants/Constants";
import styles from "./styles.module.scss";

function billingPeriodText(billingPeriod) {
    if (billingPeriod === SUBSCRIPTION_BILLING_PERIOD.MONTH) {
        return "monthly subscription";
    }

    if (billingPeriod === SUBSCRIPTION_BILLING_PERIOD.ANNUAL) {
        return "annual subscription";
    }

    return "subscription";
}

const AccountNextBilling = ({
    status,
    billingPeriod,
    nextRenewalDate,
    renewalPrice,
    showCancelLink,
    showRenewalPrice,
    productType,
    subscriptionId,
    promotionType
}) => {
    if (status === STATUS_CANCELLED || status === STATUS_EXPIRED || !nextRenewalDate || (showRenewalPrice && !renewalPrice)) {
        return null;
    }

    // 10-15-2018 [MP] This can be removed once the BConnect change for Amendment goes live
    const formattedRenewalPrice = typeof renewalPrice === "string" ? renewalPrice : renewalPrice.toFixed(2);

    return (
        <div className={ styles.accountRenewal }>
            <div>
                <span> Your { billingPeriodText(billingPeriod) } will automatically renew on </span>
                <span className={ styles.dateText }>{ getDate(nextRenewalDate) }</span>
                {
                    showRenewalPrice
                        && (
                            <span>
                                <span>, and you will be charged </span>
                                <span className={ styles.priceText }>${ formattedRenewalPrice }</span>
                            </span>
                        )
                }
                .
            </div>
            <div className={ styles.cancelContainer }>
                {
                    showCancelLink
                    && (
                        <SaveOfferModal
                            nextRenewalDate={ nextRenewalDate }
                            productType={ productType }
                            subscriptionId={ subscriptionId }
                            promotionType={ promotionType }
                            renewalPrice={ renewalPrice }
                            billingPeriod={ billingPeriod }
                        />
                    )
                }
            </div>
        </div>
    );
};

AccountNextBilling.propTypes = {
    status: PropTypes.string.isRequired,
    nextRenewalDate: PropTypes.string,
    renewalPrice: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    showCancelLink: PropTypes.bool,
    showRenewalPrice: PropTypes.bool,
    productType: PropTypes.string,
    subscriptionId: PropTypes.number,
    promotionType: PropTypes.string
};

export default AccountNextBilling;
